export default __webpack_public_path__ + "files/offline-ee17b63b6848290a0bdebcc05777acae.png";